import {ListViewProvider} from './core/ListViewProvider'
import {KTSVG} from '../../../../../_metronic/helpers'
import { VerificationListCounters } from './components/header/ListCounters'
import { useEffect, useState } from 'react'
import { downloadCsv, search } from '../../../../../utils/ajax'
import { remoteRoutes } from '../../../../../data/constants'
import toast from 'react-hot-toast'
import { overrideToastDefaults, toastMessages } from '../../../../../data/toastDefaults'
import { printMonthYear, printYearMonthDay } from '../../../../../utils/dateHelpers'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css"
import { TransferTotalChart } from './components/TransferTotalChart'
import { triggerFileDownload } from '../../../../../utils/streamlineSpecificHelpers'

const BusinessKybList = () => {
  const [verificationCount, setVerificationCount] = useState([])
  const [verifications, setVerifications] = useState([])
  const [verificationsByDate, setVerificationsByDate] = useState([])
  const [selectedType, setSelectedType]:any = useState('business_ltd')
  const [isExporting, setIsExporting]:any = useState(false)
  const [isLoadingCounts, setIsLoadingCounts]:any = useState(false)

  const toDay = new Date(), y = toDay.getFullYear(), m = toDay.getMonth();
  const firstDay = new Date(y, m, 1);
  const lastDay = new Date(y, m + 1, 0);

  const [startDate, setStartDate] = useState(firstDay);
  const [endDate, setEndDate] = useState(lastDay);

  const [from, setFrom]:any = useState(printYearMonthDay(firstDay))
  const [to, setTo]:any = useState(printYearMonthDay(lastDay))
  const [dates, setDates]:any = useState([])

  const filter = {
    start_date: from + 'T00:00',
    end_date: to + 'T23:59'
  }

  const updateFilter= (dates:any) => {
    const [start,end]: any = dates
    setFrom(printYearMonthDay(start))
    setTo(printYearMonthDay(end))
    setDates(dates)
  }

  const fetchVerificationCount = () => {
    setIsLoadingCounts(true)
    search(`${remoteRoutes.statistics}rpc/companyanalytics`, filter,
        (response) => {
          setVerificationCount(response)
          setIsLoadingCounts(false)
            if (response.length > 0) {
                toast.success(toastMessages.default.success, {
                    id: 'fetchAll',
                    ...overrideToastDefaults
                  });
            }
        },
        () => {
            toast.error(toastMessages.default.fail, overrideToastDefaults);
        },
        () => {
        }
      );
  }

  const fetchVerificationsByDate = () => {
    search(`${remoteRoutes.statistics}companyanalyticsbydate?_type=eq.${selectedType}&performed_date=gte.${filter?.start_date}&performed_date=lte.${filter?.end_date}`, {},
        (response) => {
          setVerificationsByDate(response)
        },
        () => {
            toast.error(toastMessages.default.fail, overrideToastDefaults);
        },
        () => {
        }
    );
  }

  const handleExportCounts = () => {
    setIsExporting(true)
    downloadCsv(`${remoteRoutes.statistics}rpc/companyanalytics`, filter,
      (rawFile) => {
        triggerFileDownload(rawFile, `STREAMLINE KYB Overview of ${printMonthYear(from)}.csv`)
        setIsExporting(false)
          toast.success(toastMessages.exportTotals.success, {
            id: 'fetchAll',
            ...overrideToastDefaults
          });
      },
      () => {
        toast.error(toastMessages.default.fail, overrideToastDefaults);
        setIsExporting(false)
      },
      () => {
        setIsExporting(false)
      }
    );
  }

  useEffect(() => {
    fetchVerificationsByDate()
  }, [selectedType]);

  useEffect(() => {
    fetchVerificationCount()
    fetchVerificationsByDate()
  }, [dates]);

  const onChange = (firstDay:any) => {
    const toDay = firstDay, y = toDay.getFullYear(), m = toDay.getMonth();
    const lastDay = new Date(y, m + 1, 0);
    setStartDate(firstDay);
    setEndDate(lastDay);

    if(firstDay) { updateFilter([firstDay, lastDay]) };
  };

  return (
    <>
      <div className='row mb-6'>
        <div className="col-6">
          <h3 className="card-label fw-bolder mb-0 fs-3">Totals per verification type</h3>
          <span className='text-gray-600 fw-bold fs-7'>Select a custom date range to filter verification requests by date performed</span>
        </div>
        <div className='col-6'>
          <div className='d-flex justify-content-end'>
            <DatePicker
                name="dateFilter"
                id='date-filter'
                className='btn btn-md btn-dark w-200px'
                showMonthYearPicker
                selected={startDate}
                onChange={onChange}
                dateFormat="MMMM yyyy"
            />
            {(!isExporting) && (
              <button className='btn btn-md btn-labo-primary ms-6' onClick={handleExportCounts}>
                <KTSVG path='/assets/media/icons/duotune/arrows/arr091.svg' className='svg-icon-3 text-dark' />
                Export Totals
              </button>
            )}
            {(isExporting) && (
              <button type='submit' className='btn btn-md btn-dark ms-6' disabled>
                  <span className=''>
                    Exporting Totals...{' '}
                    <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                  </span>
              </button>
            )}
          </div>
        </div>
      </div>
      <VerificationListCounters data={verificationCount} setType={setSelectedType}  loading={isLoadingCounts}/>
      <TransferTotalChart data={verificationsByDate} className='mb-10' activeType={selectedType} />
    </>
  )
}

const UsersListWrapper = () => (
  <ListViewProvider>
    <BusinessKybList />
  </ListViewProvider>
)

export {UsersListWrapper}